import { Fragment, type FunctionalComponent, h } from '@stencil/core'
import type { Item } from '../utils/api'
import type { SelectedItem } from '../utils/storage'

export interface ItemsPanelProps {
  itemsData: Item[]
  selectedItem: SelectedItem | null
  onSelectItem: (itemId: string, itemReference: string) => void
  onRefreshItems: () => void
  isLoadingAccount?: boolean
  isLoadingItems?: boolean
  itemsError?: string | null
  statusMessage?: string | null
}

export const ItemsPanel: FunctionalComponent<ItemsPanelProps> = ({
  itemsData,
  selectedItem,
  onSelectItem,
  onRefreshItems,
  isLoadingAccount,
  isLoadingItems,
  itemsError,
  statusMessage
}) => {
  const isLoading = isLoadingAccount || isLoadingItems

  return (
    <Fragment>
      <div class="debug-toolbar-control">
        <div class="flex items-center justify-between">
          <label htmlFor="debugItemSelect">Select Item</label>
          <button
            class="debug-toolbar-button-link ml-auto"
            type="button"
            onClick={onRefreshItems}
            disabled={isLoading}
          >
            {isLoadingItems ? 'Loading...' : 'Refresh Items'}
          </button>
        </div>
        <select
          id="debugItemSelect"
          onInput={e => {
            const select = e.target as HTMLSelectElement
            const selectedOption = select.selectedOptions[0]
            const itemReference = selectedOption?.getAttribute('data-item-reference')
            if (itemReference) {
              onSelectItem(select.value, itemReference)
            }
          }}
          disabled={isLoading}
          class={isLoading ? 'loading' : ''}
        >
          <option
            value=""
            disabled={isLoading}
          >
            {isLoading ? 'Loading items...' : 'Select an item...'}
          </option>
          {itemsData.map(item => (
            <option
              value={item.id}
              data-item-reference={item.reference}
              selected={selectedItem?.id === item.id}
            >
              {item.name || 'Unnamed'} ({item.id})
            </option>
          ))}
        </select>
        {itemsError && (
          <div
            class="debug-toolbar-error"
            style={{ marginTop: '8px', padding: '8px', backgroundColor: '#fee', border: '1px solid #fcc', borderRadius: '4px', color: '#c00' }}
          >
            {itemsError}
          </div>
        )}
        {statusMessage && (
          <div
            class="debug-toolbar-status"
            style={{ marginTop: '8px', padding: '8px', backgroundColor: '#e8f5e9', border: '1px solid #4caf50', borderRadius: '4px', color: '#2e7d32' }}
          >
            {statusMessage}
          </div>
        )}
      </div>
      <div class="debug-toolbar-control"></div>
      <div class="debug-toolbar-info">
        <strong>Selected Item Reference: </strong>
        <code>{selectedItem?.reference || 'None'}</code>
      </div>
    </Fragment>
  )
}
